<template>
  <div>
    <v-simple-table>
    <template >
      <thead>
        <tr>
          <th class="text-left">
            Price
            <span class="red--text">*</span>
          </th>
          <th class="text-left">
            GAP price
          </th>
          <th class="text-left">
            Reduced price
          </th>
          <th class="text-left">
            Size
            <span class="red--text">*</span>
          </th>
          <th class="text-left">
            Measurement
            <span class="red--text">*</span>
          </th>
           <th>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(object, index) in priceObject" :key="index">
          <td>
            <v-text-field solo v-model="object.price" placeholder="100"  hide-details class="py-2"/>
          </td>
          <td>
            <v-text-field solo v-model.number="object.gapPrice" placeholder="100"  hide-details class="py-2"/>
          </td>
          <td>
            <v-text-field solo v-model="object.reducedPrice" placeholder="100"  hide-details class="py-2"/>
          </td>
          <td>
            <v-text-field solo v-model="object.size" placeholder="30"  hide-details class="py-2"/>
          </td>
          <td>
            <v-text-field solo v-model="object.measurement" placeholder="G"  hide-details class="py-2"/>
          </td>
          <td class="pa-0">
             <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                   <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    v-show="index + 1 === priceObject.length"
                    small
                    @click="addPrice"
                    >
                    <v-icon>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                </template>
                <span>Add</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="mr-2" @click="removeLine(index)" small v-bind="attrs"
                    v-on="on">
                      <v-icon color="red">mdi-trash-can-outline</v-icon>
                    </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
          </td>
        </tr>
      </tbody>
    </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "Price",
  data() {
    return {
      blockRemoval: true,
    };
  },
  props: {
    priceObject: Array,
  },
  watch: {
    priceObject() {
      this.blockRemoval = this.priceObject.length <= 1;
    },
  },
  methods: {
    addPrice() {
      let checkEmptyLines = this.priceObject.filter(
        (line) => line.number === null
      );
      if (checkEmptyLines.length >= 1 && this.priceObject.length > 0) {
        return;
      }
      this.priceObject.push({
        price: null,
        gapPrice: null,
        reducedPrice: null,
        size: null,
        measurement: null,
      });
      this.$emit("givePriceToParent", this.priceObject);
    },
    removeLine(objId) {
      if (!this.blockRemoval) {
        this.priceObject.splice(objId, 1);
      }
    },
  },
  mounted() {
    this.addPrice();
  },
};
</script>